// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__I-gQt","sendOtp":"AuthorizeToLogin_sendOtp__2IBaZ"};